export const blogsData = {
  project_id: 'pid',
  district_id: 'did',
  blogs: [
    {
      month: 'Feb 2022',
      date_from: '2022-02-01',
      date_to: '2022-02-27',
      blogs: [
        {
          id: 12345,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary Feb',
          detail: '<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br><h1>Title</h1></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br>',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: false
        },
        {
          id: 1231,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary Feb',
          detail: 'full detail (html)',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: false
        },
        {
          id: 345,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary Feb',
          detail: 'full detail (html)',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: false
        },
        {
          id: 7777,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary Feb',
          detail: 'full detail 2 (html)',
          image: 'https://cdn.recyclecoach.com/blog_gallery/picnic.jpg',
          isRead: true
        }
      ]
    },
    {
      month: 'May 2022',
      date_from: '2022-05-01',
      date_to: '2022-05-30',
      blogs: [
        {
          id: 12345,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          detail: '<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br><h3>Title</h3></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br></br><h3>Title</h3></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br>',
          summary: 'Summary May randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text.',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: false
        },
        {
          id: 145,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary May randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text.',
          detail: '<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br><h1>Title</h1></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br>',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: true
        },
        {
          id: 995,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary May randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text.',
          detail: '<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br><h1>Title</h1></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br>',
          image: 'https://cdn.recyclecoach.com/blog_gallery/Reusable.png',
          isRead: false
        },
        {
          id: 7777,
          title: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
          summary: 'Summary May randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text.',
          detail: '<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br><h1>Title</h1></br><p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p></br>',
          image: 'https://cdn.recyclecoach.com/blog_gallery/picnic.jpg',
          isRead: true
        }
      ]
    }

  ]
}


export const newDashboardData = {
  reports: {
    users: {
      total: '1234',
      mobile: 1000,
      webapp: 200,
      communication: 30,
      calendar: 4
    },
    new_subscribers: '23',
    interactions: '103',
    material_searches: '32'
  },
  csm: {
    has_csm: true,
    name: 'Carly Lester',
    avatar: 'https://api-clients.recyclecoach.com/resources/image-profile/6d905eac0d95bb076805b6857d12c158.jpg',
    email: 'clester@recyclecoach.com',
    phone: '416-2331122',
    phone_ext: '112',
    calendly_link: 'www.calendly.com/cccc'
  },
  wwtk: {
    has_wwtk: true,
    question: 'Can you recycle reusable Tupperware containers?'
  }
};

export const specificCollections = [
  {
    id: 0,
    collection_nm: 'Collection 1',
  },
  {
    id: 1,
    collection_nm: 'Collection 2',
  },
  {
    id: 2,
    collection_nm: 'Collection 3',
  },
  {
    id: 3,
    collection_nm: 'Collection 4',
  },
];

export const displayMaterial = [
  {
    id: 0,
    material_nm: 'Material 1',
  },
  {
    id: 1,
    material_nm: 'Material 2',
  },
  {
    id: 2,
    material_nm: 'Material 3',
  },
  {
    id: 3,
    material_nm: 'Material 4',
  },
];

export const reminderList = [
  {
    reminders_id: 'MKyG%2FUlahcXyFgsHEi3ZAhdX67rFxf773Ssrcp392OE%3D',
    msg_title: 'Test 1',
    msg_body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    from_dt: '2020-05-13',
    to_dt: '2020-05-14',
    delete_ts: null,
    user_name: 'ahilliard',
    district_nm: 'Allamuchy',
    project_nm: 'Warren County',
    col_type_title: [
      'Branch',
      'Bulky Items',
      'Christmas Tree',
      'Clean Up Week',
      'Commingled',
      'Electronic Disposal Week',
      'Electronic Waste ',
      'Fall Cleanup',
      'Garbage',
      'Hackettstown Shredding Event',
      'Hackettstown Spring & Fall Clean Up',
      'Holiday',
      'Leaf',
      'Paper',
      'Paper Shred Event - Mansfield',
      'Recycling',
      'Township Clean-Up',
      'Warren County HHW Collection Event',
      'Warren County Paper Shredding Event',
      'Yard Waste'
    ]
  },
  {
    reminders_id: 'MKyG%2FUlahcXyFgsHEi3ZAhdX67rFxf773Ssrcp39sdadE%3D',
    msg_title: 'Test 2',
    msg_body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    from_dt: '2020-05-13',
    to_dt: '2020-05-14',
    delete_ts: null,
    user_name: 'ahilliard',
    district_nm: 'Allamuchy',
    project_nm: 'Warren County',
    col_type_title: [
      'Branch',
      'Bulky Items',
      'Christmas Tree',
      'Clean Up Week',
      'Commingled',
      'Electronic Disposal Week',
      'Electronic Waste ',
      'Fall Cleanup',
      'Garbage',
      'Hackettstown Shredding Event',
      'Hackettstown Spring & Fall Clean Up',
      'Holiday',
      'Leaf',
      'Paper',
      'Paper Shred Event - Mansfield',
      'Recycling',
      'Township Clean-Up',
      'Warren County HHW Collection Event',
      'Warren County Paper Shredding Event',
      'Yard Waste'
    ]
  },
  {
    reminders_id: 'MKyG%2FUlahcXyFgsHEi3ZAhdX67rFxfwerwSsrcp39sdadE%3D',
    msg_title: 'Test 3',
    msg_body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    from_dt: '2020-05-13',
    to_dt: '2020-05-14',
    delete_ts: null,
    user_name: 'ahilliard',
    district_nm: 'Allamuchy',
    project_nm: 'Warren County',
    col_type_title: [
      'Branch',
      'Bulky Items',
      'Christmas Tree',
      'Clean Up Week',
      'Commingled',
      'Electronic Disposal Week',
      'Electronic Waste ',
      'Fall Cleanup',
      'Garbage',
      'Hackettstown Shredding Event',
      'Hackettstown Spring & Fall Clean Up',
      'Holiday',
      'Leaf',
      'Paper',
      'Paper Shred Event - Mansfield',
      'Recycling',
      'Township Clean-Up',
      'Warren County HHW Collection Event',
      'Warren County Paper Shredding Event',
      'Yard Waste'
    ]
  },
  {
    reminders_id: 'MKyG%2FUlahcXyasdHEi3ZAhdX67rFxfwerwSsrcp39sdadE%3D',
    msg_title: 'Test 4',
    msg_body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    from_dt: '2020-05-13',
    to_dt: '2020-05-14',
    delete_ts: null,
    user_name: 'ahilliard',
    district_nm: 'Allamuchy',
    project_nm: 'Warren County',
    col_type_title: [
      'Branch',
      'Bulky Items',
      'Christmas Tree',
      'Clean Up Week',
      'Commingled',
      'Electronic Disposal Week',
      'Electronic Waste ',
      'Fall Cleanup',
      'Garbage',
      'Hackettstown Shredding Event',
      'Hackettstown Spring & Fall Clean Up',
      'Holiday',
      'Leaf',
      'Paper',
      'Paper Shred Event - Mansfield',
      'Recycling',
      'Township Clean-Up',
      'Warren County HHW Collection Event',
      'Warren County Paper Shredding Event',
      'Yard Waste'
    ]
  },
  {
    reminders_id: 'MKyG%2FUlahcXyasdasd3ZAhdX67rFxfwerwSsrcp39sdadE%3D',
    msg_title: 'Test 5',
    msg_body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    from_dt: '2020-05-13',
    to_dt: '2020-05-14',
    delete_ts: null,
    user_name: 'ahilliard',
    district_nm: 'Allamuchy',
    project_nm: 'Warren County',
    col_type_title: [
      'Branch',
      'Bulky Items',
      'Christmas Tree',
      'Clean Up Week',
      'Commingled',
      'Electronic Disposal Week',
      'Electronic Waste ',
      'Fall Cleanup',
      'Garbage',
      'Hackettstown Shredding Event',
      'Hackettstown Spring & Fall Clean Up',
      'Holiday',
      'Leaf',
      'Paper',
      'Paper Shred Event - Mansfield',
      'Recycling',
      'Township Clean-Up',
      'Warren County HHW Collection Event',
      'Warren County Paper Shredding Event',
      'Yard Waste'
    ]
  },
];

export const usersList = [
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '1'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test1',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '2'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test2',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 'f',
    id: '3'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test3',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '4'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test4',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '5'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test5',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 'f',
    id: '6'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test6',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '7'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test7',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '8'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test8',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '9'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test9',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  }, {
    project: [{ project_nm: 'test' }],
    user_name: 'test10',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '11'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test11',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '12'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test12',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '13'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test13',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test14',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test15',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test16',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test17',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test18',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test19',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  },
  {
    project: [{ project_nm: 'test' }],
    user_name: 'test20',
    first_name: 'test',
    last_name: 'gggg',
    email: 'gggg@gg.com',
    phone: '98987',
    last_login_dt: '2020-03-02',
    active: 't',
    id: '10'
  }
];

export const campaignList = [
  {
    id: 1,
    title: 'Spring Cleaning',
    activities: ['video', 'comic', 'quiz', 'poll', 'video'],
    active: false,
    startDate: '2020-05-16',
    endDate: '2020-05-29',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
  },
  {
    id: 2,
    title: 'Earth Month',
    activities: ['ingographic', 'comic', 'poll', 'poll', 'video'],
    active: true,
    startDate: '2020-06-05',
    endDate: '2020-07-2',
    description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.',
  },
  {
    id: 3,
    title: 'Don\'t bag your recylings',
    activities: ['comic', 'video', 'comic', 'video'],
    active: false,
    startDate: '2020-08-08',
    endDate: '2020-08-16',
    description: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
  },
  {
    id: 4,
    title: 'Plastic bags',
    activities: ['video', 'poll', 'quiz', 'comic', 'video', 'quiz', 'quiz'],
    active: false,
    startDate: '2020-11-01',
    endDate: '2020-11-25',
    description: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.',
  }
];

export const userReport = {
  summary: {
    current_period: 62497,
    last_period: 62350,
    rating: 142,
    peer_rating: 155,
  },
  detail: {
    mobile: {
      total: 58397,
      iOS: 16354,
      android: 41326
    },
    web_app: {
      total: 4103,
      detail: [
        {
          title: 'web app 1',
          value: 2345
        },
        {
          title: 'web app 2',
          value: 159
        },
        {
          title: 'web app 3',
          value: 978
        },
      ]
    },
    communications: {
      total: 273150,
      detail: [
        {
          title: 'Email',
          value: 2345
        },
        {
          title: 'SMS',
          value: 159
        },
        {
          title: 'Phone',
          value: 978
        },
      ]
    },
    calendars: {
      total: 3930,
      detail: [
        {
          title: 'PDF',
          value: 2345
        },
        {
          title: 'Synced',
          value: 159
        },
      ]
    },
  },
  detail_peer: {
    mobile: {
      rating: 102,
      peer_rating: 105,
    },
    web_app: {
      rating: 80,
      peer_rating: 90,
    },
    communications: {
      rating: 150,
      peer_rating: 110,
    },
    calendars: {
      rating: 110,
      peer_rating: 105,
    },
  },
};

export const interactionReport = {
  summary: {
    current_period: 62497,
    last_period: 62350,
    rating: 142,
    peer_rating: 155,
  },
  detail: {
    reminder: {
      total: 58397,
      detail: [
        {
          title: 'Mobile App',
          value: 2345
        },
        {
          title: 'Email',
          value: 159
        },
        {
          title: 'SMS',
          value: 978
        },
        {
          title: 'Phone',
          value: 45326
        },
      ]
    },
    notification: {
      total: 4103,
      detail: [
        {
          title: 'General',
          value: 2345
        },
        {
          title: 'Emergency',
          value: 159
        },
        {
          title: 'Campaigns',
          value: 978
        },
        {
          title: 'Problems',
          value: 24
        },
      ]
    },
    material: {
      total: 273150,
    },
    page: {
      total: 1326,
    },
    calendar: {
      total: 3930,
    },
  },
  detail_peer: {
    reminder: {
      rating: 102,
      peer_rating: 105,
    },
    notification: {
      rating: 80,
      peer_rating: 90,
    },
    material: {
      rating: 150,
      peer_rating: 110,
    },
    page: {
      rating: 110,
      peer_rating: 105,
    },
    calendar: {
      rating: 110,
      peer_rating: 105,
    },
  },
};

export const materialReport = {
  summary: {
    titles: [
      'Yard Waste',
      'Bulky Items',
      'Recycling',
      'Another Waste Type',
      'Another Waste Type',
      'Garbage'
    ],
    current_period: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ],
    previous_period: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ],
    last_year: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ]
  },
  detail: {
    total: {
      current_period: Math.floor(Math.random() * 100000),
      previous_period: Math.floor(Math.random() * 100000),
      last_year: Math.floor(Math.random() * 100000)
    },
    materials: [
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
      {
        title: `Material ${Math.floor(Math.random() * 1000)}`,
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20)
      },
    ]
  },
};

export const newSubscribersReport = {
  summary: {
    current_period: 62497,
    last_period: 62350,
    rating: 142,
    peer_rating: 155,
  },
  detail: {
    mobile: {
      total: 58397,
      iOS: 16354,
      android: 41326
    },
    email: {
      total: 4103,
      detail: [
        {
          title: 'email 1',
          value: 2345
        },
        {
          title: 'email 2',
          value: 159
        },
        {
          title: 'email 3',
          value: 978
        },
      ]
    },
    sms: {
      total: 273150,
      detail: [
        {
          title: 'SMS 1',
          value: 2345
        },
        {
          title: 'SMS 2',
          value: 159
        },
        {
          title: 'SMS 3',
          value: 978
        },
      ]
    },
    call: {
      total: 3930,
      detail: [
        {
          title: 'Phone 1',
          value: 2345
        },
        {
          title: 'Phone 2',
          value: 159
        },
      ]
    },
  },
  detail_peer: {
    mobile: {
      rating: 102,
      peer_rating: 105,
    },
    email: {
      rating: 80,
      peer_rating: 90,
    },
    sms: {
      rating: 150,
      peer_rating: 110,
    },
    call: {
      rating: 110,
      peer_rating: 105,
    },
  },
};

export const pageViewsReport = {
  summary: {
    titles: [
      'Depots',
      'Events',
      'General Pages',
      'Material Searches',
      'Report a Problem',
      'News',
      'Campaigns',
      'Blog Articles',
      'Calendar',
      'Collection Requirement',
    ],
    current_period: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ],
    previous_period: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ],
    last_year: [
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
      Math.floor(Math.random() * 100),
    ]
  },
  detail: {
    total: {
      current_period: Math.floor(Math.random() * 100000),
      previous_period: Math.floor(Math.random() * 100000),
      last_year: Math.floor(Math.random() * 100000)
    },
    views: [
      {
        title: 'Calendar',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Collection Requirement',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Depots',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Blog Articles',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'General Pages',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Material Searches',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Report a Problem',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'News',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Campaigns',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
      {
        title: 'Events',
        current_period: Math.floor(Math.random() * 10000),
        current_period_rank: Math.floor(Math.random() * 20),
        previous_period: Math.floor(Math.random() * 10000),
        previous_period_rank: Math.floor(Math.random() * 20),
        last_year: Math.floor(Math.random() * 10000),
        last_year_rank: Math.floor(Math.random() * 20),
        detail: [
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          },
          {
            title: `Item number ${Math.floor(Math.random() * 10)}`,
            current_period: Math.floor(Math.random() * 1000),
            last_period: Math.floor(Math.random() * 1000),
            last_year: Math.floor(Math.random() * 1000),
          }
        ]
      },
    ]
  },
};

export const problemReport = {
  summary: {
    current_period: 62497,
    last_period: 62350,
    app_support_total: 34256,
    missed_collection_total: 22345,
    other_total: 10930,
  },
  detail: [
    {
      date: '2020-06-28',
      problem_type: 'Other Collection 1',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 2',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 3',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 4',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 5',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 6',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 7',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 8',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 9',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 10',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 11',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 12',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 13',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 14',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 15',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
    {
      date: '2020-06-28',
      problem_type: 'Missed Collection 16',
      name: 'John Doe',
      address: '203 pandora st',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      phone_number: '226 234 1015',
      email: 'john.doe@gmail.com',
      district: 'London',
    },
  ],
};

export const campaignReportData = [
  {
    id: 1352,
    start_date: 'Mon Dec 23 2019',
    end_date: 'Fri Jan 31 2020',
    invited_users: 22788,
    name: 'Corrugated Cardboard',
    participation: '8989',
    participation_rate: '41.5 %'
  },
  {
    id: 1352,
    start_date: 'Mon Oct 17 2019',
    end_date: 'Fri Jan 28 2020',
    invited_users: 34335,
    name: 'Earth Month',
    participation: '3434',
    participation_rate: '71.5 %'
  },
  {
    id: 1352,
    start_date: 'Mon Dec 10 2019',
    end_date: 'Fri Jul 12 2020',
    invited_users: 67674,
    name: 'Back to basics',
    participation: '4900',
    participation_rate: '21.5 %'
  },
  {
    id: 1352,
    start_date: 'Mon jul 28 2019',
    end_date: 'Fri Jan 8 2020',
    invited_users: 34342,
    name: 'Empty Clean',
    participation: '5454',
    participation_rate: '91.5 %'
  }
];

export const DetailCampaignReportData = {
  coachables: [
    {
      id: 3360,
      type: 'quiz3',
      open: 4900,
      participation: 3589,
      further_info: [
        { title: 'Correct Answer', value: 3124 },
        { title: 'Wrong Answer', value: 465 }],
      description: 'Question: Is this the proper way to set out multiple cardboard boxes? ',
      options: ['Yes', 'No'],
    },
    {
      id: 3361,
      type: 'quiz',
      open: 3124,
      participation: 2994,
      further_info: [
        { title: 'Correct Answer', value: 2613 },
        { title: 'Wrong Answer', value: 381 }
      ],
      description: 'Question: Will collection workers accept boxes if they are folded and contained in your recycling bin like this?',
      options: ['Ok', 'No'],
    },
    {
      id: 3362,
      type: 'quiz2',
      open: 2920,
      participation: 2877,
      further_info: [{ title: 'Correct Answer', value: 2521 },
      { title: 'Wrong Answer', value: 356 }],
      description: 'Question: Is this the proper way to set out cardboard boxes?',
      options: ['Yes', 'No'],
    }],
  status: 'success'
};

export const CategoryData = {};
